import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Search } from 'lucide-react';
import { forwardRef } from 'react';
import { cn } from "../lib/cn.js";
import { Input } from "./input.js";
export const ListToolbar = ({ children, actions, className, }) => (_jsxs("div", { className: cn('flex flex-wrap items-end gap-3', className), children: [children, actions === undefined ? null : (_jsx("div", { className: "ml-auto flex flex-wrap items-center gap-2", children: actions }))] }));
/**
 * Busca com a lupa dentro do campo.
 *
 * O `aria-label` continua obrigação de quem chama — "Buscar produtos" diz mais
 * que "Buscar", e a lupa é decorativa.
 */
export const SearchInput = forwardRef(({ wrapperClassName, className, ...props }, ref) => (_jsxs("div", { className: cn('relative min-w-56 flex-1', wrapperClassName), children: [_jsx(Search, { "aria-hidden": "true", className: "pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-(--text-muted)" }), _jsx(Input, { ref: ref, type: "search", className: cn('pl-8', className), ...props })] })));
SearchInput.displayName = 'SearchInput';
//# sourceMappingURL=list-toolbar.js.map